import './scripts/common';
import {onFind} from "./libs/@elements/init-modules-in-scope";

import Popover from 'bootstrap/js/dist/popover';
onFind('[data-bs-toggle="popover"]', function (element) {
    new Popover(element, {})
});

if (!window.HTMLPictureElement) {
    import('picturefill');
}

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

/**********************************
 *
 *      Project Stuff
 *
 * ********************************/
import * as numberSpinner from './libs/@elements/number-spinner';
// numberSpinner.init();
onFind('.js-number-spinner', function (numberSpinnerElement) {
    numberSpinner.createNumberSpinner(numberSpinnerElement, {}, {
        base: '.js-number-spinner',
        input: '.js-number-spinner__input',
        upButton: '.js-number-spinner__plus',
        downButton: '.js-number-spinner__minus'
    });
});

import * as submitForm from './scripts/submitForm';
submitForm.init();

import * as cartBadge from './scripts/cartBadge';
cartBadge.init();
 
